/** video events
 * @static
 * @constant
 * @private
 * @memberof video/core
*/
export const VideoEvents = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'volumechange',
];

/** video 可以取值的属性
 * @static
 * @constant
 * @private
 * @memberof video/core
*/
export const videoPropertiesByGet = [
    /**
     * Paused for core tech
     *
     * @method Core.prototype.paused
     * @return {Boolean}
     */
    'paused',
    /**
     * Get current time
     *
     * @method Core.prototype.currentTime
     * @return {Number}
     */
    'currentTime',
    /**
     * Get a TimeRange object that represents the intersection
     * of the time ranges for which the user agent has all
     * relevant media
     *
     * @return {TimeRangeObject}
     * @method Core.prototype.buffered
     */
    'buffered',
    /**
     * Get volume level
     *
     * @return {Number}
     * @method Core.prototype.volume
     */
    'volume',
    /**
     * Get if muted
     *
     * @return {Boolean}
     * @method Core.prototype.muted
     */
    'muted',
    /**
     * Get poster
     *
     * @return {String}
     * @method Core.prototype.poster
     */
    'poster',
    /**
     * Get preload attribute
     *
     * @return {String}
     * @method Core.prototype.preload
     */
    'preload',
    /**
     * Get autoplay attribute
     *
     * @return {String}
     * @method Core.prototype.autoplay
     */
    'autoplay',
    /**
     * Get controls attribute
     *
     * @return {String}
     * @method Core.prototype.controls
     */
    'controls',
    /**
     * Get loop attribute
     *
     * @return {String}
     * @method Core.prototype.loop
     */
    'loop',
    /**
     * Get error value
     *
     * @return {String}
     * @method Core.prototype.error
     */
    'error',
    /**
     * Get whether or not the player is in the "seeking" state
     *
     * @return {Boolean}
     * @method Core.prototype.seeking
     */
    'seeking',
    /**
     * Get a TimeRanges object that represents the
     * ranges of the media resource to which it is possible
     * for the user agent to seek.
     *
     * @return {TimeRangeObject}
     * @method Core.prototype.seekable
     */
    'seekable',
    /**
     * Get if video ended
     *
     * @return {Boolean}
     * @method Core.prototype.ended
     */
    'ended',
    /**
     * Get the value of the muted content attribute
     * This attribute has no dynamic effect, it only
     * controls the default state of the element
     *
     * @return {Boolean}
     * @method Core.prototype.defaultMuted
     */
    'defaultMuted',
    /**
     * Get desired speed at which the media resource is to play
     *
     * @return {Number}
     * @method Core.prototype.playbackRate
     */
    'playbackRate',
    /**
     * Returns a TimeRanges object that represents the ranges of the
     * media resource that the user agent has played.
     * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-played
     *
     * @return {TimeRangeObject} the range of points on the media
     *                           timeline that has been reached through
     *                           normal playback
     * @method Core.prototype.played
     */
    'played',
    /**
     * Get the current state of network activity for the element, from
     * the list below
     * - NETWORK_EMPTY (numeric value 0)
     * - NETWORK_IDLE (numeric value 1)
     * - NETWORK_LOADING (numeric value 2)
     * - NETWORK_NO_SOURCE (numeric value 3)
     *
     * @return {Number}
     * @method Core.prototype.networkState
     */
    'networkState',
    /**
     * Get a value that expresses the current state of the element
     * with respect to rendering the current playback position, from
     * the codes in the list below
     * - HAVE_NOTHING (numeric value 0)
     * - HAVE_METADATA (numeric value 1)
     * - HAVE_CURRENT_DATA (numeric value 2)
     * - HAVE_FUTURE_DATA (numeric value 3)
     * - HAVE_ENOUGH_DATA (numeric value 4)
     *
     * @return {Number}
     * @method Core.prototype.readyState
     */
    'readyState',
    /**
     * Get width of video
     *
     * @return {Number}
     * @method Core.prototype.videoWidth
     */
    'videoWidth',
    /**
     * Get height of video
     *
     * @return {Number}
     * @method Core.prototype.videoHeight
     */
    'videoHeight',
    'duration',
];

/** video 可以设置的属性
 * @static
 * @constant
 * @private
 * @memberof video/core
*/
export const videoPropertiesBySet = [
    /**
     * Set volume level
     *
     * @param {Number} percentAsDecimal Volume percent as a decimal
     * @method Core.prototype.setVolume
     */
    'volume',
    /**
     * Set muted
     *
     * @param {Boolean} muted If player is to be muted or note
     * @method Core.prototype.setMuted
     */
    'muted',
    /**
     * Set video source
     *
     * @param {Object} src Source object
     * @deprecated since version 5
     * @method Core.prototype.setSrc
     */
    'poster',
    /**
     * Set preload attribute
     *
     * @param {String} val Value for the preload attribute
     * @method Htm5.prototype.setPreload
     */
    'preload',
    /**
     * Set autoplay attribute
     *
     * @param {Boolean} autoplay Value for the autoplay attribute
     * @method setAutoplay
     */
    'autoplay',
    /**
     * Set loop attribute
     *
     * @param {Boolean} loop Value for the loop attribute
     * @method Core.prototype.setLoop
     */
    'loop',
    /**
     * Set desired speed at which the media resource is to play
     *
     * @param {Number} val Speed at which the media resource is to play
     * @method Core.prototype.setPlaybackRate
     */
    'playbackRate',
];



// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/modules/core/video.js